import AppUtilities from './app-utilities';

export default AppUtilities;